const getThreeDSecureData = state => state.payment?.threeDSecureData;

export default getThreeDSecureData;
